import { Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import API from "../../../services/API";

export default function Top({title}){

    const {id} = useParams()

    const [course, setCourse] = useState(null)

    useEffect(() => {

        if(id !== 'new'){

            API.get(`/courses/${id}`)
                .then(r => setCourse(r.data))

        }
    
    }, [id])

    return <Stack spacing={3} sx={{pt: 3}}>

        <Typography variant='h1'>{title}</Typography>

        {course?.title && 
            <Typography variant='h4'>{course.title}</Typography>
        }

    </Stack>
}